// React
import React from 'react';
// External libraries
import { Button, Nav, Navbar } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Internal
import getActivePath from 'utils/getActivePath';
import { isOwner } from 'services/users';
import signOutCognito from 'utils/signOutCognito';
// Styles
import './styles.scss';

class NavbarSecondary extends React.Component {
    constructor(props) {
        super(props);
        this.location = props.location;
    }

    logout = () => {
        signOutCognito();
        // navigates to login page
        this.props.history.push('/login');
    };

    render() {
        return (
            <Navbar className="navbar-secondary">
                <Nav className="nav-right-aligned">
                    <Nav.Link
                        href="/tagging-guide"
                        className={getActivePath(this.location, '/tagging-guide') ? 'active' : null}
                    >
                        Tagging Guide
                    </Nav.Link>
                    <Nav.Link
                        href="/customer-support"
                        className={getActivePath(this.location, '/customer-support') ? 'active' : null}
                    >
                        Customer Support
                    </Nav.Link>
                    {/* 
                        isOwner()
                            ? (
                                <Nav.Link
                                    href="/manage-practice"
                                    className={getActivePath(this.location, '/manage-practice') ? 'active' : null}
                                >
                                    Manage Practice
                                </Nav.Link>
                            ) : null
                    } */}
                    <Nav.Link
                        href="/profile"
                        className={getActivePath(this.location, '/profile') ? 'active' : null}
                    >
                        Profile
                    </Nav.Link>
                    <Button
                        variant="link"
                        onClick={() => this.logout()}
                        className={getActivePath(this.location, '/logout') ? 'active' : null}
                    >
                        Logout
                    </Button>
                </Nav>
            </Navbar>
        );
    }
}

export default withRouter(NavbarSecondary);
